import { jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Input, Select } from "antd";
import { getT } from "../../../../../../_utils/intl";
const { Option } = Select;
const SelectPhoneOrEmail = ({ value, onChange, changeGenre }) => {
  const t = getT();
  const [type, setType] = useState("phone");
  const selectBefore = /* @__PURE__ */ jsxs(
    Select,
    {
      defaultValue: "+86",
      onChange: (v) => {
        console.log("\u533A\u53F7", v);
      },
      children: [
        /* @__PURE__ */ jsx(Option, { value: "+86", children: "+86" }),
        /* @__PURE__ */ jsx(Option, { value: "+43", children: "+43" }),
        /* @__PURE__ */ jsx(Option, { value: "+43", children: "..." })
      ]
    }
  );
  const selectAfter = /* @__PURE__ */ jsxs(
    Select,
    {
      value: type,
      disabled: true,
      onChange: (v) => {
        changeGenre(v);
        setType(v);
      },
      children: [
        /* @__PURE__ */ jsx(Option, { value: "phone", children: t("login.captcha.phone") }),
        /* @__PURE__ */ jsx(Option, { value: "email", children: t("login.captcha.email") })
      ]
    }
  );
  return /* @__PURE__ */ jsx(
    Input,
    {
      value,
      onChange: (e) => onChange == null ? void 0 : onChange(e.target.value),
      placeholder: type === "phone" ? t("login.placeholder.phone") : t("login.placeholder.email"),
      addonBefore: type === "phone" ? selectBefore : null,
      addonAfter: selectAfter
    }
  );
};
var SelectPhoneOrEmail_default = SelectPhoneOrEmail;
export {
  SelectPhoneOrEmail_default as default
};
